import React from "react";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { LeftArrowIcon } from "@icons";
import { ChildrenProps } from "../../../types";
import styles from "./Footer.module.scss";

interface Props extends ChildrenProps {
    className?: string;
    onBack?(): void;
    onBackDisabled?: boolean;
}

export const Footer: React.FC<Props> = ({
    onBack,
    onBackDisabled,
    className,
    children,
}) => (
    <footer className={classNames(styles.footer, className)}>
        {onBack && (
            <Button
                type="button"
                variant="primary"
                iconOnly
                onClick={onBack}
                disabled={onBackDisabled}
                size="xl"
                aria-label="Go back"
            >
                <LeftArrowIcon />
            </Button>
        )}

        <div>{children}</div>
    </footer>
);
